import FBMultiDateDesc from "./container/MultiDateDescLanding";

export default FBMultiDateDesc;
